import { Link } from "react-router-dom";

export default function WebinarTopBar() {
  return (
    <div className="w-full bg-navy text-white text-sm py-2.5 px-4 flex items-center justify-between flex-wrap gap-2">
      <div className="flex items-center gap-2 flex-1 min-w-0">
        <span className="w-4 h-4 flex items-center justify-center flex-shrink-0">
          <i className="ri-shield-check-fill text-primary text-xs" />
        </span>
        <span className="text-white/80 text-xs sm:text-sm whitespace-nowrap overflow-hidden text-ellipsis">
          <strong className="text-white font-semibold">SOC 2 Type II Certified</strong> AI Calling Infrastructure
          <span className="hidden sm:inline text-white/50">
            {" "}&nbsp;|&nbsp; Built for title, mortgage, and regulated industries
          </span>
        </span>
      </div>
      <div className="flex items-center gap-3 flex-shrink-0">
        <div className="flex items-center gap-2">
          <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse flex-shrink-0" />
          <span className="text-green-300 font-semibold text-xs whitespace-nowrap">
            <span className="hidden sm:inline">Live Webinar </span>Registration Open
          </span>
        </div>
        <Link
          to="/"
          className="text-white/50 text-xs hover:text-white/80 transition-colors hidden md:inline whitespace-nowrap"
        >
          ← Main Site
        </Link>
      </div>
    </div>
  );
}
